goog.provide('el8.appchart.visitNote.timer');

el8.appchart.visitNote.timer = function(spec) {
    this._time = 0;
    this._timeStartMillis = null; // null when timer not unpaused
    this._container = spec.container;

    this._stateChangedFn = spec.stateChangedFn || null;

    // Possible states are 'ended', 'unpaused', and 'paused'
    // All of the functions unpause(), end(), and pause() can be called from any state.
    this._state = null;

    this._timerField = $(':input[name="timer"]', this._container);
    this._buttonsElt = $('.timer-buttons', this._container);
    this._pauseTrigger = $('.pause-trigger', this._buttonsElt);
    this._stopTrigger = $('.stop-trigger', this._buttonsElt);

    var that = this;
    this._pauseTrigger.click(function(event) {
        switch(that.getState()) {
            case 'unpaused':
                that.pause();
                break;
            case 'ended':
            case 'paused':
                that.unpause();
                break;
        }
        return false;
    });

    this._stopTrigger.click(function(event) {
        that.end();
        return false;
    });

    this.end(true);
};

el8.appchart.visitNote.timer.prototype.setTime = function(time) {
    if (time !== undefined && time !== null && time !== this._time) { 
        this._time = time;
        if (this._timeStartMillis) {
            this._timeStartMillis = Date.now() - time * 1000;
        }
        this._updateTimerField();
    }
    return this;
};

el8.appchart.visitNote.timer.prototype.getTime = function() {
    return this._time;
};

el8.appchart.visitNote.timer.prototype.unpause = function(noUpdate) {
    var that = this;

    this._timeStartMillis = Date.now() - this._time * 1000;
    this._timerField.stopTime();
    this._timerField.everyTime("1s", function() {
        that._time = Math.round((Date.now() - that._timeStartMillis) / 1000);
        that._updateTimerField();
    });

    this._pauseTrigger.text('Pause');
    this._stopTrigger.show();
    this._state = 'unpaused';

    if (!noUpdate && this._stateChangedFn) { this._stateChangedFn(this); }
};

el8.appchart.visitNote.timer.prototype.pause = function(noUpdate) {
    this._timerField.stopTime();
    this._timeStartMillis = null;

    this._pauseTrigger.text('Resume');
    this._stopTrigger.show();
    this._state = 'paused';

    if (!noUpdate && this._stateChangedFn) { this._stateChangedFn(this); }
};

el8.appchart.visitNote.timer.prototype.end = function(noUpdate) {
    this._timerField.stopTime();
    this._timeStartMillis = null;

    this._pauseTrigger.text('Start');
    this._stopTrigger.hide();
    this._state = 'ended';

    if (!noUpdate && this._stateChangedFn) { this._stateChangedFn(this); }
};

el8.appchart.visitNote.timer.prototype.pauseIfNotEnded = function(noUpdate) {
    if (this._state !== 'ended' && this._state !== 'paused') {
        this.pause(noUpdate);
        return true;
    }
    else {
        return false;
    }
};

el8.appchart.visitNote.timer.prototype.unpauseIfNotEnded = function(noUpdate) {
    if (this._state !== 'ended' && this._state !== 'unpaused') {
        this.unpause(noUpdate);
        return true;
    }
    else {
        return false;
    }
};

el8.appchart.visitNote.timer.prototype.hideButtons = function() {
    this._buttonsElt.hide();
    return this;
};

el8.appchart.visitNote.timer.prototype.showButtons = function() {
    this._buttonsElt.show();
    return this;
};

el8.appchart.visitNote.timer.prototype.getState = function() {
    return this._state;
};

el8.appchart.visitNote.timer.prototype._updateTimerField = function() {
    this._timerField.val($.secondsToStr(this._time));
};
